import { UrlUtils } from '@atlassian/mpac-utils';
const {
  updateQueryParam
} = UrlUtils;
export const redirectToNewQuery = _ref => {
  let {
    query,
    locationHref,
    history
  } = _ref;
  const isSearchPage = locationHref.includes('/search');
  if (isSearchPage) {
    const updatedPathname = updateQueryParam(locationHref, 'query', query);
    history === null || history === void 0 ? void 0 : history.push(updatedPathname);
  } else {
    history === null || history === void 0 ? void 0 : history.push("/search?query=".concat(query));
  }
};